import React from 'react'

const Footer = () => {
  const currentYear = new Date().getFullYear();
  return (
    <div className='w-full bg-black p-10'>
      <p className='text-white text-center'>
        Copyright © {currentYear} La Esquina - Authentic Taqueria
      </p>
    </div>
  )
}

export default Footer